var map = {
	"./DataScience/2023": 27665,
	"./DataScience/2023.json": 27665,
	"./DataScience/2024": 32418,
	"./DataScience/2024.json": 32418,
	"./DataScience/2025": 38648,
	"./DataScience/2025.json": 38648,
	"./DataScience/blog": 60855,
	"./DataScience/blog.json": 60855,
	"./DataScience/follow": 32959,
	"./DataScience/follow.json": 32959,
	"./DataScience/images/YannLeCun.jpg": 1678,
	"./DataScience/images/andrej_karpathy.jpg": 66732,
	"./DataScience/images/andrew.jpg": 26415,
	"./DataScience/images/andrew_ng.jpg": 29138,
	"./DataScience/images/cassie_kozyrkov.jpg": 68536,
	"./DataScience/images/daphne_koller.jpg": 43595,
	"./DataScience/images/francois_chollet.jpg": 33694,
	"./DataScience/images/hadley_wickham.jpg": 59288,
	"./DataScience/images/hilary_mason.jpg": 27033,
	"./DataScience/images/jeremy_howard.jpg": 89101,
	"./DataScience/images/josh_gordon.jpg": 68962,
	"./DataScience/images/kaggle.jpg": 28775,
	"./DataScience/images/kdnuggets.jpg": 16934,
	"./DataScience/images/kieran_healy.jpg": 5435,
	"./DataScience/images/matei_zaharia.jpg": 86853,
	"./DataScience/images/peter_norvig.jpg": 82905,
	"./DataScience/images/rachel-thomas.jpg": 68313,
	"./DataScience/images/sebastian_raschka.jpg": 62941,
	"./DataScience/images/thomas_wolf.jpg": 84019,
	"./DataScience/images/tom_dietterich.jpg": 68602,
	"./DataScience/images/yann_lecun.jpg": 35937,
	"./DataScience/years": 18887,
	"./DataScience/years.json": 18887,
	"./ai/2018": 32532,
	"./ai/2018.json": 32532,
	"./ai/2019": 75262,
	"./ai/2019.json": 75262,
	"./ai/2020": 92644,
	"./ai/2020.json": 92644,
	"./ai/2021": 40854,
	"./ai/2021.json": 40854,
	"./ai/2022": 38554,
	"./ai/2022.json": 38554,
	"./ai/2023": 51535,
	"./ai/2023.json": 51535,
	"./ai/2024": 36417,
	"./ai/2024.json": 36417,
	"./ai/2025": 33142,
	"./ai/2025.json": 33142,
	"./ai/blog": 25115,
	"./ai/blog.json": 25115,
	"./ai/categories": 74175,
	"./ai/categories.json": 74175,
	"./ai/follow": 48967,
	"./ai/follow.json": 48967,
	"./ai/images/Adam-Geitgey.jpg": 55107,
	"./ai/images/Alec-Radford.jpg": 8774,
	"./ai/images/AndrewNg.jpg": 50521,
	"./ai/images/Fchollet.jpg": 95081,
	"./ai/images/GeoffreyHinton.jpg": 97335,
	"./ai/images/JJ-Kardwell.jpg": 47003,
	"./ai/images/Joanna.jpg": 72095,
	"./ai/images/Nathan.jpg": 76108,
	"./ai/images/Soumith.jpg": 14645,
	"./ai/images/YannLeCun.jpg": 55928,
	"./ai/images/adam.png": 77868,
	"./ai/images/ai-logo.png": 70460,
	"./ai/images/ai.gif": 51340,
	"./ai/images/alexjc.png": 5962,
	"./ai/images/andrej-karpathy.webp": 99304,
	"./ai/images/andrew.jpg": 44746,
	"./ai/images/cybercode.jpg": 66812,
	"./ai/images/elon.jpg": 44162,
	"./ai/images/fei-fei-li.jpg": 73104,
	"./ai/images/geoffrey-hinton.jpg": 22123,
	"./ai/images/ian-goodfellow.jpg": 2017,
	"./ai/images/ilya-sutskever.jpg": 81851,
	"./ai/images/jana.jpg": 84507,
	"./ai/images/johnc.jpg": 42583,
	"./ai/images/juhani.jpg": 49928,
	"./ai/images/martin.jpg": 48725,
	"./ai/images/rachel-thomas.jpg": 19577,
	"./ai/images/thumb_Nathan_Benaich.jpg": 2982,
	"./ai/images/yann-lecun.jpg": 76086,
	"./ai/years": 63948,
	"./ai/years.json": 63948,
	"./android/2017": 58333,
	"./android/2017.json": 58333,
	"./android/2018": 25391,
	"./android/2018.json": 25391,
	"./android/2019": 31297,
	"./android/2019.json": 31297,
	"./android/2020": 90828,
	"./android/2020.json": 90828,
	"./android/2021": 77845,
	"./android/2021.json": 77845,
	"./android/2022": 55278,
	"./android/2022.json": 55278,
	"./android/2023": 94748,
	"./android/2023.json": 94748,
	"./android/2024": 51286,
	"./android/2024.json": 51286,
	"./android/2025": 26106,
	"./android/2025.json": 26106,
	"./android/blog": 68946,
	"./android/blog.json": 68946,
	"./android/follow": 34263,
	"./android/follow.json": 34263,
	"./android/images/Amrit_Sanjeev.jpg": 19574,
	"./android/images/AndrejKarpathy.jpg": 69145,
	"./android/images/AndyRubin.jpg": 47452,
	"./android/images/ChetHaase.jpg": 78559,
	"./android/images/ChrisBanes.jpg": 70377,
	"./android/images/ChrisLacy.jpg": 78196,
	"./android/images/ClementDelangue.jpg": 86807,
	"./android/images/DannyPostma.jpg": 78344,
	"./android/images/DonnFelker.jpg": 22044,
	"./android/images/DroidSmith.jpg": 90612,
	"./android/images/FlorinaMuntenescu.jpg": 60230,
	"./android/images/GinaTrapani.png": 10834,
	"./android/images/IanLake.jpg": 4725,
	"./android/images/JackClark.jpg": 66304,
	"./android/images/JakeWharton.png": 41722,
	"./android/images/JamesKendrick.jpg": 19267,
	"./android/images/JoaquimVerges.jpg": 19344,
	"./android/images/JuhaniLehtimaki.jpg": 61010,
	"./android/images/LelandRichardson.jpg": 19612,
	"./android/images/MatiasDuarte.jpg": 59414,
	"./android/images/NickButcher.jpg": 57780,
	"./android/images/PhilippLackner.jpg": 97086,
	"./android/images/RetoMeier.jpg": 84542,
	"./android/images/RomainGuy.jpg": 29056,
	"./android/images/SamAltman.jpg": 43387,
	"./android/images/XavierDucrohet.jfif": 92771,
	"./android/images/XavierDucrohet.jpg": 31001,
	"./android/images/android-logo.png": 82410,
	"./android/images/cyanogen.jpg": 19620,
	"./android/images/saschasegan.jpg": 14871,
	"./android/images/sundarpichai.jpg": 78863,
	"./android/years": 93652,
	"./android/years.json": 93652,
	"./arvr/2018": 29439,
	"./arvr/2018.json": 29439,
	"./arvr/2019": 23963,
	"./arvr/2019.json": 23963,
	"./arvr/2020": 44553,
	"./arvr/2020.json": 44553,
	"./arvr/2021": 141,
	"./arvr/2021.json": 141,
	"./arvr/2022": 3860,
	"./arvr/2022.json": 3860,
	"./arvr/2023": 49088,
	"./arvr/2023.json": 49088,
	"./arvr/2024": 10694,
	"./arvr/2024.json": 10694,
	"./arvr/2025": 60090,
	"./arvr/2025.json": 60090,
	"./arvr/blog": 41321,
	"./arvr/blog.json": 41321,
	"./arvr/follow": 95148,
	"./arvr/follow.json": 95148,
	"./arvr/images/AlexKipman.jpg": 68709,
	"./arvr/images/AlexSchwartz.jpg": 84852,
	"./arvr/images/ChrisMilk.jpg": 4285,
	"./arvr/images/ClayBavor.jpg": 92118,
	"./arvr/images/JensChristensen.jpg": 24984,
	"./arvr/images/JohnCarmack.jpg": 18936,
	"./arvr/images/JoostVanSchaik.jpg": 26072,
	"./arvr/images/JustinPBarnett.jpg": 65722,
	"./arvr/images/KentBye.jpg": 18699,
	"./arvr/images/PalmerLuckey.jpg": 93179,
	"./arvr/images/TonyParisi.jpg": 85620,
	"./arvr/images/VRFocus.jpg": 69758,
	"./arvr/images/arvr-logo.png": 54086,
	"./arvr/years": 25878,
	"./arvr/years.json": 25878,
	"./backend/2022": 87815,
	"./backend/2022.json": 87815,
	"./backend/2023": 30398,
	"./backend/2023.json": 30398,
	"./backend/2025": 77676,
	"./backend/2025.json": 77676,
	"./backend/blog": 1332,
	"./backend/blog.json": 1332,
	"./backend/follow": 19123,
	"./backend/follow.json": 19123,
	"./backend/images/Alex_xu.jpg": 28544,
	"./backend/images/BenSigelman.png": 56277,
	"./backend/images/CharityMajors.png": 68087,
	"./backend/images/Hussein_Nasser.jpg": 10807,
	"./backend/images/KelseyHightower.png": 39148,
	"./backend/images/MartinKleppmann.jpg": 18776,
	"./backend/images/backend-logo.png": 64918,
	"./backend/years": 39479,
	"./backend/years.json": 39479,
	"./bioinformatics/2017": 89139,
	"./bioinformatics/2017.json": 89139,
	"./bioinformatics/2018": 15076,
	"./bioinformatics/2018.json": 15076,
	"./bioinformatics/2019": 12818,
	"./bioinformatics/2019.json": 12818,
	"./bioinformatics/2020": 50250,
	"./bioinformatics/2020.json": 50250,
	"./bioinformatics/2021": 30744,
	"./bioinformatics/2021.json": 30744,
	"./bioinformatics/2022": 35131,
	"./bioinformatics/2022.json": 35131,
	"./bioinformatics/2023": 40482,
	"./bioinformatics/2023.json": 40482,
	"./bioinformatics/2024": 3003,
	"./bioinformatics/2024.json": 3003,
	"./bioinformatics/2025": 2913,
	"./bioinformatics/2025.json": 2913,
	"./bioinformatics/blog": 13615,
	"./bioinformatics/blog.json": 13615,
	"./bioinformatics/follow": 4268,
	"./bioinformatics/follow.json": 4268,
	"./bioinformatics/images/David R. Liu.jpg": 16094,
	"./bioinformatics/images/Feng Zhang.jpg": 44541,
	"./bioinformatics/images/Manolis Kellis.jpg": 62739,
	"./bioinformatics/images/Steven Salzberg.jpg": 13165,
	"./bioinformatics/years": 64265,
	"./bioinformatics/years.json": 64265,
	"./biotech/2017": 11015,
	"./biotech/2017.json": 11015,
	"./biotech/2018": 93684,
	"./biotech/2018.json": 93684,
	"./biotech/2019": 64712,
	"./biotech/2019.json": 64712,
	"./biotech/2020": 18294,
	"./biotech/2020.json": 18294,
	"./biotech/2021": 69722,
	"./biotech/2021.json": 69722,
	"./biotech/2022": 43019,
	"./biotech/2022.json": 43019,
	"./biotech/2023": 46274,
	"./biotech/2023.json": 46274,
	"./biotech/2024": 67678,
	"./biotech/2024.json": 67678,
	"./biotech/2025": 26794,
	"./biotech/2025.json": 26794,
	"./biotech/blog": 16192,
	"./biotech/blog.json": 16192,
	"./biotech/follow": 15084,
	"./biotech/follow.json": 15084,
	"./biotech/images/adam.jpg": 97820,
	"./biotech/images/andy.png": 83016,
	"./biotech/images/biotech-logo.png": 62449,
	"./biotech/images/matthew.jpg": 13998,
	"./biotech/images/meg.jpg": 81977,
	"./biotech/images/sally.jpg": 1583,
	"./biotech/years": 26895,
	"./biotech/years.json": 26895,
	"./blockchain/2017": 99096,
	"./blockchain/2017.json": 99096,
	"./blockchain/2018": 19806,
	"./blockchain/2018.json": 19806,
	"./blockchain/2019": 1594,
	"./blockchain/2019.json": 1594,
	"./blockchain/2020": 45818,
	"./blockchain/2020.json": 45818,
	"./blockchain/2021": 44253,
	"./blockchain/2021.json": 44253,
	"./blockchain/2022": 64195,
	"./blockchain/2022.json": 64195,
	"./blockchain/2023": 19874,
	"./blockchain/2023.json": 19874,
	"./blockchain/2024": 17622,
	"./blockchain/2024.json": 17622,
	"./blockchain/2025": 39444,
	"./blockchain/2025.json": 39444,
	"./blockchain/blog": 28359,
	"./blockchain/blog.json": 28359,
	"./blockchain/follow": 71027,
	"./blockchain/follow.json": 71027,
	"./blockchain/images/Andreas.jpg": 43238,
	"./blockchain/images/VitalikButerin.jpg": 42999,
	"./blockchain/images/blockchain-logo.png": 54013,
	"./blockchain/images/corda.jpg": 11609,
	"./blockchain/images/david.jpg": 41730,
	"./blockchain/images/dtapscott.jpg": 2015,
	"./blockchain/images/ethereum.jpg": 86662,
	"./blockchain/images/preethi.jpg": 56398,
	"./blockchain/images/william.jpg": 24660,
	"./blockchain/years": 13656,
	"./blockchain/years.json": 13656,
	"./creativedesign/2023": 70204,
	"./creativedesign/2023.json": 70204,
	"./creativedesign/2024": 41963,
	"./creativedesign/2024.json": 41963,
	"./creativedesign/2025": 32910,
	"./creativedesign/2025.json": 32910,
	"./creativedesign/blog": 62286,
	"./creativedesign/blog.json": 62286,
	"./creativedesign/creativedesignblogs/2023": 95445,
	"./creativedesign/creativedesignblogs/2023.json": 95445,
	"./creativedesign/creativedesignblogs/2024": 54856,
	"./creativedesign/creativedesignblogs/2024.json": 54856,
	"./creativedesign/creativedesignblogs/2025": 5786,
	"./creativedesign/creativedesignblogs/2025.json": 5786,
	"./creativedesign/follow": 90861,
	"./creativedesign/follow.json": 90861,
	"./creativedesign/images/cdesign.png": 91028,
	"./creativedesign/images/david_airey.jpg": 4393,
	"./creativedesign/images/jessica_hische.jpg": 37972,
	"./creativedesign/images/jony_ive.jpg": 64267,
	"./creativedesign/images/natasha_jen.jpg": 83478,
	"./creativedesign/images/paula_scher.jpg": 24276,
	"./creativedesign/images/sagmeister_walsh.jpg": 3090,
	"./creativedesign/years": 73438,
	"./creativedesign/years.json": 73438,
	"./cybersecurity/2017": 51473,
	"./cybersecurity/2017.json": 51473,
	"./cybersecurity/2018": 77492,
	"./cybersecurity/2018.json": 77492,
	"./cybersecurity/2019": 22063,
	"./cybersecurity/2019.json": 22063,
	"./cybersecurity/2020": 48626,
	"./cybersecurity/2020.json": 48626,
	"./cybersecurity/2021": 24003,
	"./cybersecurity/2021.json": 24003,
	"./cybersecurity/2022": 66823,
	"./cybersecurity/2022.json": 66823,
	"./cybersecurity/2023": 34152,
	"./cybersecurity/2023.json": 34152,
	"./cybersecurity/2024": 75300,
	"./cybersecurity/2024.json": 75300,
	"./cybersecurity/2025": 51782,
	"./cybersecurity/2025.json": 51782,
	"./cybersecurity/blog": 95597,
	"./cybersecurity/blog.json": 95597,
	"./cybersecurity/follow": 73552,
	"./cybersecurity/follow.json": 73552,
	"./cybersecurity/images/SwiftOnSecurity.jpg": 22252,
	"./cybersecurity/images/bruce.jpeg": 2824,
	"./cybersecurity/images/catalin.jpeg": 38053,
	"./cybersecurity/images/christopher.jpg": 72062,
	"./cybersecurity/images/cybersec.png": 29626,
	"./cybersecurity/images/florian.jpeg": 94252,
	"./cybersecurity/images/keren.jpg": 50595,
	"./cybersecurity/images/kimzetter.jpg": 61701,
	"./cybersecurity/images/lesley.jpg": 57222,
	"./cybersecurity/images/maddie.jpg": 71094,
	"./cybersecurity/images/mikko.jpg": 58497,
	"./cybersecurity/images/troy.jpeg": 93823,
	"./cybersecurity/years": 48594,
	"./cybersecurity/years.json": 48594,
	"./database/2023": 67186,
	"./database/2023.json": 67186,
	"./database/2024": 5369,
	"./database/2024.json": 5369,
	"./database/2025": 64977,
	"./database/2025.json": 64977,
	"./database/blog": 2123,
	"./database/blog.json": 2123,
	"./database/follow": 57119,
	"./database/follow.json": 57119,
	"./database/images/Bruce_Momjian.jpg": 87158,
	"./database/images/Kelsey_Hightower.jpg": 73514,
	"./database/images/Mark_Callaghan.jpg": 84480,
	"./database/images/Werner_Vogels.jpg": 69985,
	"./database/years": 67609,
	"./database/years.json": 67609,
	"./devops/2017": 95021,
	"./devops/2017.json": 95021,
	"./devops/2018": 87803,
	"./devops/2018.json": 87803,
	"./devops/2019": 60078,
	"./devops/2019.json": 60078,
	"./devops/2020": 48141,
	"./devops/2020.json": 48141,
	"./devops/2021": 63178,
	"./devops/2021.json": 63178,
	"./devops/2022": 21133,
	"./devops/2022.json": 21133,
	"./devops/2023": 7925,
	"./devops/2023.json": 7925,
	"./devops/2024": 49466,
	"./devops/2024.json": 49466,
	"./devops/2025": 74980,
	"./devops/2025.json": 74980,
	"./devops/blog": 81507,
	"./devops/blog.json": 81507,
	"./devops/follow": 1410,
	"./devops/follow.json": 1410,
	"./devops/images/AndrewClayShafer.jpg": 42567,
	"./devops/images/AndrewHay.jpg": 13746,
	"./devops/images/CourtneyNash.jpg": 1489,
	"./devops/images/DamonEdwards.jpg": 71836,
	"./devops/images/DominicaDeGrandis.jpg": 34278,
	"./devops/images/GeneKim.jpg": 57661,
	"./devops/images/GeorgeSpafford.jpg": 36753,
	"./devops/images/JezHumble.jpg": 27817,
	"./devops/images/JulianSimpson.jpg": 23537,
	"./devops/images/KevinBehr.jpg": 96095,
	"./devops/images/MandiWalls.jpg": 40835,
	"./devops/images/MarkR.Hinkle.jpg": 63064,
	"./devops/images/MartenMickos.jpg": 85196,
	"./devops/images/MartinFowler.jpg": 18601,
	"./devops/images/Sascha.jpg": 28767,
	"./devops/images/StephenNelson-Smith.jpg": 51248,
	"./devops/images/XavierAmatriain.jpg": 98874,
	"./devops/images/adrianco.jpg": 75174,
	"./devops/images/allspaw.jpg": 72911,
	"./devops/images/andrew-clay-shafer.png": 64959,
	"./devops/images/estherderby.jpg": 30756,
	"./devops/images/hullsean.jpg": 47773,
	"./devops/images/joemckendrick.jpg": 84524,
	"./devops/images/mark_r.jpg": 1452,
	"./devops/images/security-logo.png": 41632,
	"./devops/years": 15335,
	"./devops/years.json": 15335,
	"./edgecomputing/2017": 32716,
	"./edgecomputing/2017.json": 32716,
	"./edgecomputing/2018": 28317,
	"./edgecomputing/2018.json": 28317,
	"./edgecomputing/2019": 23832,
	"./edgecomputing/2019.json": 23832,
	"./edgecomputing/2020": 90526,
	"./edgecomputing/2020.json": 90526,
	"./edgecomputing/2021": 6045,
	"./edgecomputing/2021.json": 6045,
	"./edgecomputing/2022": 83004,
	"./edgecomputing/2022.json": 83004,
	"./edgecomputing/2023": 86573,
	"./edgecomputing/2023.json": 86573,
	"./edgecomputing/2024": 37596,
	"./edgecomputing/2024.json": 37596,
	"./edgecomputing/2025": 9337,
	"./edgecomputing/2025.json": 9337,
	"./edgecomputing/blog": 62961,
	"./edgecomputing/blog.json": 62961,
	"./edgecomputing/follow": 53429,
	"./edgecomputing/follow.json": 53429,
	"./edgecomputing/images/Andrej Karpathy.jpg": 62537,
	"./edgecomputing/images/Werner Vogels.jpg": 28289,
	"./edgecomputing/years": 25021,
	"./edgecomputing/years.json": 25021,
	"./embedded-system/2025": 48226,
	"./embedded-system/2025.json": 48226,
	"./embedded-system/blog": 87644,
	"./embedded-system/blog.json": 87644,
	"./embedded-system/follow": 13095,
	"./embedded-system/follow.json": 13095,
	"./embedded-system/images/Bhavesh.jpg": 70145,
	"./embedded-system/images/Ian.jpg": 40478,
	"./embedded-system/images/John.jpg": 54509,
	"./embedded-system/years": 6219,
	"./embedded-system/years.json": 6219,
	"./foss/2025": 39466,
	"./foss/2025.json": 39466,
	"./foss/blog": 54165,
	"./foss/blog.json": 54165,
	"./foss/follow": 35038,
	"./foss/follow.json": 35038,
	"./foss/images/Ansh-Arora.jpg": 26926,
	"./foss/images/Deb-Nicholson.jpg": 51498,
	"./foss/images/Deepu-S-Nath.jpg": 23451,
	"./foss/images/Greg-Kroah-Hartman.jpg": 39502,
	"./foss/images/Karen-Sandler.jpg": 4303,
	"./foss/images/Linus-Torvalds.jpg": 16151,
	"./foss/images/Mark-Shuttleworth.jpg": 56460,
	"./foss/images/Miguel-de-Icaza.jpg": 79535,
	"./foss/images/Moosa-Mehar.jpg": 98900,
	"./foss/images/Rahul-Poruri.jpg": 84025,
	"./foss/images/Richard-Stallman.jpg": 93500,
	"./foss/images/Rushabh-Mehta.jpg": 92716,
	"./foss/images/Satish-Babu.jpg": 80947,
	"./foss/images/Sunil-TT.jpg": 12237,
	"./foss/images/Vishal-Arya.jpg": 52254,
	"./foss/years": 35825,
	"./foss/years.json": 35825,
	"./frontend/2017": 77535,
	"./frontend/2017.json": 77535,
	"./frontend/2018": 50056,
	"./frontend/2018.json": 50056,
	"./frontend/2019": 9743,
	"./frontend/2019.json": 9743,
	"./frontend/2020": 13247,
	"./frontend/2020.json": 13247,
	"./frontend/2021": 66843,
	"./frontend/2021.json": 66843,
	"./frontend/2022": 7708,
	"./frontend/2022.json": 7708,
	"./frontend/2023": 15403,
	"./frontend/2023.json": 15403,
	"./frontend/2024": 70252,
	"./frontend/2024.json": 70252,
	"./frontend/2025": 85179,
	"./frontend/2025.json": 85179,
	"./frontend/blog": 12409,
	"./frontend/blog.json": 12409,
	"./frontend/follow": 42062,
	"./frontend/follow.json": 42062,
	"./frontend/images/JohnResig.jpg": 57357,
	"./frontend/images/KyleSimpson.jpeg": 45478,
	"./frontend/images/KyleSimpson.jpg": 13913,
	"./frontend/images/addy.jpg": 35929,
	"./frontend/images/archibald.jpg": 91826,
	"./frontend/images/frontend-logo.png": 75849,
	"./frontend/images/grigorik.jpg": 26530,
	"./frontend/images/heilmann.jpg": 24338,
	"./frontend/images/irish.jpg": 74725,
	"./frontend/images/nicholas.jpg": 70311,
	"./frontend/images/souders.jpg": 82199,
	"./frontend/images/sullivan.jpg": 10528,
	"./frontend/images/verou.jpg": 2609,
	"./frontend/years": 9196,
	"./frontend/years.json": 9196,
	"./generative-ai/2024": 54561,
	"./generative-ai/2024.json": 54561,
	"./generative-ai/2025": 30427,
	"./generative-ai/2025.json": 30427,
	"./generative-ai/blog": 39417,
	"./generative-ai/blog.json": 39417,
	"./generative-ai/follow": 27124,
	"./generative-ai/follow.json": 27124,
	"./generative-ai/images/andrew.jpeg": 4987,
	"./generative-ai/images/demis.jpeg": 84137,
	"./generative-ai/images/fei.webp": 45633,
	"./generative-ai/images/kate.jpg": 68204,
	"./generative-ai/years": 9758,
	"./generative-ai/years.json": 9758,
	"./home": 5993,
	"./home.json": 5993,
	"./ios/2017": 40670,
	"./ios/2017.json": 40670,
	"./ios/2018": 757,
	"./ios/2018.json": 757,
	"./ios/2019": 24378,
	"./ios/2019.json": 24378,
	"./ios/2020": 4060,
	"./ios/2020.json": 4060,
	"./ios/2021": 26947,
	"./ios/2021.json": 26947,
	"./ios/2022": 7655,
	"./ios/2022.json": 7655,
	"./ios/2023": 97753,
	"./ios/2023.json": 97753,
	"./ios/2024": 75594,
	"./ios/2024.json": 75594,
	"./ios/2025": 35023,
	"./ios/2025.json": 35023,
	"./ios/blog": 15481,
	"./ios/blog.json": 15481,
	"./ios/follow": 66026,
	"./ios/follow.json": 66026,
	"./ios/images/AshFurrow.jpg": 49382,
	"./ios/images/ChrisEidhof.jpg": 34755,
	"./ios/images/ChrisLattner.jpg": 64474,
	"./ios/images/DaveVerwer.jpg": 95958,
	"./ios/images/FelixKrause.jpg": 60274,
	"./ios/images/JohnSundell.jpg": 95681,
	"./ios/images/MattGemmell.jpg": 87196,
	"./ios/images/Mattt.jpg": 48671,
	"./ios/images/OleBegemann.jpg": 1829,
	"./ios/images/OrtaTherox.jpg": 91575,
	"./ios/images/PeterSteinberger.jpg": 43134,
	"./ios/images/SimonNg.jpg": 54828,
	"./ios/images/TimCook.jpg": 13194,
	"./ios/images/ios-logo.png": 83633,
	"./ios/images/mac.jpg": 18185,
	"./ios/images/matt_galloway.jpg": 69532,
	"./ios/images/raywenderlich.jpg": 71152,
	"./ios/years": 42666,
	"./ios/years.json": 42666,
	"./iot/2024": 21635,
	"./iot/2024.json": 21635,
	"./iot/2025": 58419,
	"./iot/2025.json": 58419,
	"./iot/blog": 19207,
	"./iot/blog.json": 19207,
	"./iot/follow": 35973,
	"./iot/follow.json": 35973,
	"./iot/images/AlexWilliams.jpg": 7568,
	"./iot/images/AlexandraDS.jpg": 70648,
	"./iot/images/AndrewScott.jpg": 68216,
	"./iot/images/IoTForAll.jpg": 33371,
	"./iot/images/KevinAshton.jpg": 93237,
	"./iot/images/PeteWarden.jpg": 1002,
	"./iot/images/StaceyHigginbotham.jpg": 36429,
	"./iot/images/iot.png": 4465,
	"./iot/years": 17023,
	"./iot/years.json": 17023,
	"./marketing/2023": 65463,
	"./marketing/2023.json": 65463,
	"./marketing/2024": 21842,
	"./marketing/2024.json": 21842,
	"./marketing/2025": 19624,
	"./marketing/2025.json": 19624,
	"./marketing/blog": 15188,
	"./marketing/blog.json": 15188,
	"./marketing/follow": 64112,
	"./marketing/follow.json": 64112,
	"./marketing/images/and_fishkin.jpg": 71384,
	"./marketing/images/ann_handley.jpg": 21098,
	"./marketing/images/ann_handley.png": 10660,
	"./marketing/images/danny_sullivan.jpg": 60764,
	"./marketing/images/gary_vaynerchuk.jpg": 80309,
	"./marketing/images/mark_schaefer.jpg": 75364,
	"./marketing/images/moz.jpg": 18607,
	"./marketing/images/neil_patel.jpg": 51680,
	"./marketing/images/neil_patel.png": 35664,
	"./marketing/images/rand_fishkin.jpg": 48504,
	"./marketing/images/seth_godin.jpg": 5580,
	"./marketing/images/sorav-jain-digital-marketing-influencer.png": 42182,
	"./marketing/images/sorav-jain.jpg": 49644,
	"./marketing/years": 90674,
	"./marketing/years.json": 90674,
	"./photonics/2017": 44054,
	"./photonics/2017.json": 44054,
	"./photonics/2018": 83108,
	"./photonics/2018.json": 83108,
	"./photonics/2019": 127,
	"./photonics/2019.json": 127,
	"./photonics/2020": 8585,
	"./photonics/2020.json": 8585,
	"./photonics/2021": 45707,
	"./photonics/2021.json": 45707,
	"./photonics/2022": 28036,
	"./photonics/2022.json": 28036,
	"./photonics/2023": 24807,
	"./photonics/2023.json": 24807,
	"./photonics/2024": 86997,
	"./photonics/2024.json": 86997,
	"./photonics/2025": 56570,
	"./photonics/2025.json": 56570,
	"./photonics/blog": 60366,
	"./photonics/blog.json": 60366,
	"./photonics/follow": 22021,
	"./photonics/follow.json": 22021,
	"./photonics/images/Andrea Alù.jpg": 37791,
	"./photonics/images/Federico Capasso.jpg": 59303,
	"./photonics/images/Miles Padgett.jpg": 13924,
	"./photonics/images/Nader Engheta.jpg": 17431,
	"./photonics/years": 43637,
	"./photonics/years.json": 43637,
	"./pm/2023": 9661,
	"./pm/2023.json": 9661,
	"./pm/2024": 82949,
	"./pm/2024.json": 82949,
	"./pm/2025": 70633,
	"./pm/2025.json": 70633,
	"./pm/blog": 19307,
	"./pm/blog.json": 19307,
	"./pm/follow": 23869,
	"./pm/follow.json": 23869,
	"./pm/images/bandan.jpg": 47943,
	"./pm/images/cagan.jpg": 33090,
	"./pm/images/chris_bakke.jpg": 69880,
	"./pm/images/jen_yang_wong.jpg": 9137,
	"./pm/images/lenny_rachitsky.jpg": 7029,
	"./pm/images/shreyas_doshi.jpg": 87819,
	"./pm/images/toby_rogers.jpg": 53574,
	"./pm/images/trung_phan.jpg": 6974,
	"./pm/product-management-blogs/2023": 90719,
	"./pm/product-management-blogs/2023.json": 90719,
	"./pm/product-management-blogs/2024": 99855,
	"./pm/product-management-blogs/2024.json": 99855,
	"./pm/product-management-blogs/2025": 95621,
	"./pm/product-management-blogs/2025.json": 95621,
	"./pm/years": 89257,
	"./pm/years.json": 89257,
	"./qa/2017": 1840,
	"./qa/2017.json": 1840,
	"./qa/2018": 44131,
	"./qa/2018.json": 44131,
	"./qa/2019": 23913,
	"./qa/2019.json": 23913,
	"./qa/2020": 70251,
	"./qa/2020.json": 70251,
	"./qa/2021": 4538,
	"./qa/2021.json": 4538,
	"./qa/2022": 75658,
	"./qa/2022.json": 75658,
	"./qa/2023": 88063,
	"./qa/2023.json": 88063,
	"./qa/2024": 24894,
	"./qa/2024.json": 24894,
	"./qa/2025": 14065,
	"./qa/2025.json": 14065,
	"./qa/blog": 50176,
	"./qa/blog.json": 50176,
	"./qa/follow": 13859,
	"./qa/follow.json": 13859,
	"./qa/images/AjayBalamurugadas.jpg": 12941,
	"./qa/images/AntonAngelov.jpg": 32853,
	"./qa/images/PeteWalen.jpg": 66666,
	"./qa/images/alan_page.jpg": 67805,
	"./qa/images/angie_jones.jpg": 17862,
	"./qa/images/bret_pettichord.jpg": 24927,
	"./qa/images/cem_kaner.jpg": 99555,
	"./qa/images/gary_masnica.jpg": 62659,
	"./qa/images/gojko_adic.jpg": 4288,
	"./qa/images/james_bach.jpg": 19592,
	"./qa/images/lisacrispin.jpg": 959,
	"./qa/images/michael_bolton.jpg": 23095,
	"./qa/images/ministry_of_test.jpg": 41177,
	"./qa/images/qa-logo.png": 56607,
	"./qa/years": 64742,
	"./qa/years.json": 64742,
	"./quantum-computing/2017": 32392,
	"./quantum-computing/2017.json": 32392,
	"./quantum-computing/2018": 62625,
	"./quantum-computing/2018.json": 62625,
	"./quantum-computing/2019": 66959,
	"./quantum-computing/2019.json": 66959,
	"./quantum-computing/2020": 50942,
	"./quantum-computing/2020.json": 50942,
	"./quantum-computing/2021": 82072,
	"./quantum-computing/2021.json": 82072,
	"./quantum-computing/2022": 37922,
	"./quantum-computing/2022.json": 37922,
	"./quantum-computing/2023": 57925,
	"./quantum-computing/2023.json": 57925,
	"./quantum-computing/2024": 67875,
	"./quantum-computing/2024.json": 67875,
	"./quantum-computing/2025": 26163,
	"./quantum-computing/2025.json": 26163,
	"./quantum-computing/blog": 1948,
	"./quantum-computing/blog.json": 1948,
	"./quantum-computing/follow": 9769,
	"./quantum-computing/follow.json": 9769,
	"./quantum-computing/images/ChadRigetti.jpg": 46785,
	"./quantum-computing/images/abraham_asfaw.jpg": 89114,
	"./quantum-computing/images/amira_abbas.jpg": 26727,
	"./quantum-computing/images/anastasia_marchenkova.jpg": 71488,
	"./quantum-computing/images/illyas_khan.jpeg": 16490,
	"./quantum-computing/images/illyas_khan.jpg": 38154,
	"./quantum-computing/images/junye_huang.jpg": 12014,
	"./quantum-computing/images/maria_schuld.jpeg": 12692,
	"./quantum-computing/images/olivia_lanes.jpg": 70338,
	"./quantum-computing/images/zlatko_minev.jpg": 26753,
	"./quantum-computing/years": 51523,
	"./quantum-computing/years.json": 51523,
	"./robotics-automation/2023": 95486,
	"./robotics-automation/2023.json": 95486,
	"./robotics-automation/2024": 57301,
	"./robotics-automation/2024.json": 57301,
	"./robotics-automation/2025": 43818,
	"./robotics-automation/2025.json": 43818,
	"./robotics-automation/blog": 30067,
	"./robotics-automation/blog.json": 30067,
	"./robotics-automation/follow": 72451,
	"./robotics-automation/follow.json": 72451,
	"./robotics-automation/images/Cynthia.jpg": 7789,
	"./robotics-automation/images/Steve.jpg": 54584,
	"./robotics-automation/images/lex.jpg": 7125,
	"./robotics-automation/years": 37970,
	"./robotics-automation/years.json": 37970,
	"./space-technology/2023": 7509,
	"./space-technology/2023.json": 7509,
	"./space-technology/2024": 68484,
	"./space-technology/2024.json": 68484,
	"./space-technology/2025": 70305,
	"./space-technology/2025.json": 70305,
	"./space-technology/blog": 94106,
	"./space-technology/blog.json": 94106,
	"./space-technology/follow": 87079,
	"./space-technology/follow.json": 87079,
	"./space-technology/images/Chris.jpg": 25765,
	"./space-technology/images/Dan.jpeg": 57822,
	"./space-technology/images/John_m.jpeg": 16356,
	"./space-technology/images/Nobu.webp": 53084,
	"./space-technology/images/kellie.webp": 92053,
	"./space-technology/images/kevin.jpg": 71354,
	"./space-technology/images/kevin.webp": 13421,
	"./space-technology/images/peter.jpg": 82827,
	"./space-technology/images/robert.jpg": 16215,
	"./space-technology/images/sara.jpg": 5784,
	"./space-technology/years": 45100,
	"./space-technology/years.json": 45100,
	"./uiux/2023": 64972,
	"./uiux/2023.json": 64972,
	"./uiux/2024": 91839,
	"./uiux/2024.json": 91839,
	"./uiux/2025": 4983,
	"./uiux/2025.json": 4983,
	"./uiux/blog": 25726,
	"./uiux/blog.json": 25726,
	"./uiux/follow": 40992,
	"./uiux/follow.json": 40992,
	"./uiux/images/don_norman.jpg": 43919,
	"./uiux/images/farai-madzima.jpg": 43211,
	"./uiux/images/irene_au.jpg": 12239,
	"./uiux/images/jakob_nielsen.jpg": 31783,
	"./uiux/images/john_maeda.jpg": 89320,
	"./uiux/images/julie_zhuo.jpg": 47630,
	"./uiux/images/luke_wroblewski.jpg": 32270,
	"./uiux/images/scott_jenson.jpg": 72501,
	"./uiux/images/susan_weinschenk.jpg": 61137,
	"./uiux/uiuxblogs/2023": 84447,
	"./uiux/uiuxblogs/2023.json": 84447,
	"./uiux/uiuxblogs/2024": 96759,
	"./uiux/uiuxblogs/2024.json": 96759,
	"./uiux/uiuxblogs/2025": 18094,
	"./uiux/uiuxblogs/2025.json": 18094,
	"./uiux/years": 62980,
	"./uiux/years.json": 62980,
	"./web/2017": 66129,
	"./web/2017.json": 66129,
	"./web/2018": 20230,
	"./web/2018.json": 20230,
	"./web/2019": 38052,
	"./web/2019.json": 38052,
	"./web/2020": 85006,
	"./web/2020.json": 85006,
	"./web/2021": 32964,
	"./web/2021.json": 32964,
	"./web/2022": 54184,
	"./web/2022.json": 54184,
	"./web/2023": 97627,
	"./web/2023.json": 97627,
	"./web/2024": 4719,
	"./web/2024.json": 4719,
	"./web/2025": 44430,
	"./web/2025.json": 44430,
	"./web/blog": 96510,
	"./web/blog.json": 96510,
	"./web/follow": 94712,
	"./web/follow.json": 94712,
	"./web/images/AddyOsmani.jpg": 3272,
	"./web/images/AndiGutmans.jpg": 95890,
	"./web/images/Anthony.jpg": 15385,
	"./web/images/BradFrost.jpg": 1826,
	"./web/images/ChrisCoyier.jpg": 37041,
	"./web/images/DanAbramov.jpg": 25817,
	"./web/images/DavidWalsh.jpg": 12097,
	"./web/images/DerickRethans.jpg": 22918,
	"./web/images/JenSimmons.jpg": 72558,
	"./web/images/JordiBoggiano.jpg": 8877,
	"./web/images/JuanTreminio.jpg": 17884,
	"./web/images/KentCDodds.jpg": 82880,
	"./web/images/LeaVerou.jpg": 9570,
	"./web/images/LukasKahweSmith.jpg": 3807,
	"./web/images/LukeWroblewski.jpg": 15227,
	"./web/images/Luke_Wroblewski.webp": 23738,
	"./web/images/MoshHamedani.jpg": 3462,
	"./web/images/PaulIrish.jpg": 72858,
	"./web/images/RachelAndrew.jpg": 40409,
	"./web/images/RobAllen.jpg": 32239,
	"./web/images/SarahDrasner.jpg": 51792,
	"./web/images/SebastianBergmann.jpg": 57541,
	"./web/images/TaylorOtwell.jpg": 9065,
	"./web/images/UnaKravets.jpg": 80525,
	"./web/images/WesBos.jpg": 52226,
	"./web/images/brad_frost.jpg": 14936,
	"./web/images/web-logo.png": 35192,
	"./web/images/weierophinney.jpg": 64564,
	"./web/years": 4237,
	"./web/years.json": 4237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86482;